import React, { Component } from 'react';
import { connect } from 'react-redux';
import Newssidebar from '../newssidebar/newssidebar';
import Sidebar from '../sidebar/sidebar';
import {featuredImageWithFallback, imageWithFallback, newsCategories} from '../../utilities';
import moment from 'moment';
import ScrollbarArea from '../scrollbararea/scrollbararea';

moment.locale('nl');

import './newsitem.css';
import has from "lodash.has";
import {Helmet} from "react-helmet";

class Newsitem extends Component {
    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        let newsitem = {
            title: "",
            content: ""
        }

        if (has(this,'props.news.news')) {
            let foundNewsItem = this.props.news.news.find((newsitem) => {
                return (newsitem.slug === this.props.match.params.newsitemslug);
            });

            if (foundNewsItem) {
                newsitem = foundNewsItem;
            }
        }

        let newsImage = featuredImageWithFallback(newsitem);

        if (has(newsitem, 'sidebar_afbeelding.sizes') && newsitem.sidebar_afbeelding !== false && newsitem.sidebar_afbeelding !== null) {
            newsImage = imageWithFallback(newsitem.sidebar_afbeelding, 'medium_large');
        }

        return (
            <div className="newsitem">
                <Helmet>
                    <title>{newsitem.title.rendered} - KWOOT</title>
                    <meta property="og:title" content={newsitem.title.rendered + ' - KWOOT'} />
                    {newsImage && <meta property="og:image" content={newsImage} />}
                </Helmet>
                <Sidebar title={newsitem.title.rendered} image={newsImage} groupbuttontitle="Alle berichten" groupbuttonlink="/actueel" supertitle={newsCategories(newsitem)} date={moment(newsitem.date).format("D MMMM YYYY")} />
                <ScrollbarArea
                    speed={0.8}
                    className="newsitem__contentarea"
                    contentClassName="newsitem__content"
                    horizontal={false}
                >
                    <div dangerouslySetInnerHTML={{__html: newsitem.content.rendered}}></div>
                </ScrollbarArea>
                <Newssidebar></Newssidebar>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        news: state.news,
        newsById: state.newsById
    }
}

export default connect(mapStateToProps)(Newsitem);



// WEBPACK FOOTER //
// ./src/components/newsitem/newsitem.js